var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry, actionExecutionLocations) {
    pluginRegistry.registerDeploymentAction("Octopus.AzureServiceFabricApp", function(octopusRepository) {
        return {
            executionLocation: actionExecutionLocations.alwaysOnServer,
            canChooseRoles: true,
            canHaveChildren: function(){return false;},
            canBeChild: false,
            hasPackages: function(action) { return true; },
            features: {
                optional: [
                    "Octopus.Features.ConfigurationTransforms",
                    "Octopus.Features.ConfigurationVariables",
                    "Octopus.Features.CustomScripts",
                    "Octopus.Features.JsonConfigurationVariables",
                    "Octopus.Features.SubstituteInFiles"
                ]
            },
            summaryTemplateUrl: "areas/projects/actions/azure_service_fabric_app/Octopus.AzureServiceFabricApp_summary.html",
            editTemplateUrl: "areas/projects/actions/azure_service_fabric_app/Octopus.AzureServiceFabricApp_edit.html",
            preLink: function (scope) {
                scope.app = {
                };
                
                if (!scope.action.Properties['Octopus.Action.ServiceFabric.OverrideUpgradeBehavior']) {
                    scope.action.Properties['Octopus.Action.ServiceFabric.OverrideUpgradeBehavior'] = "None";
                }
                if (!scope.action.Properties['Octopus.Action.ServiceFabric.OverwriteBehavior']) {
                    scope.action.Properties['Octopus.Action.ServiceFabric.OverwriteBehavior'] = "SameAppTypeAndVersion";
                }
                if (!scope.action.Properties['Octopus.Action.ServiceFabric.SecurityMode']) {
                    scope.action.Properties['Octopus.Action.ServiceFabric.SecurityMode'] = "Unsecure";
                }
                // TODO: markse - Note that this default can be removed once Azure adds support for ClientCertificate credential types.
                if (!scope.action.Properties['Octopus.Action.ServiceFabric.AadCredentialType']) {
                    scope.action.Properties['Octopus.Action.ServiceFabric.AadCredentialType'] = "UserCredential";
                }

                scope.resetValues = {
                    ClientCertVariable: scope.action.Properties["Octopus.Action.ServiceFabric.ClientCertVariable"],
                    CertificateFindValueOverride: scope.action.Properties["Octopus.Action.ServiceFabric.CertificateFindValueOverride"]
                };
            },
            summaryLink: function($scope, element) {
                return octopusRepository.Feeds.get($scope.properties["Octopus.Action.Package.FeedId"]).then(function(feed){
                    $scope.feedName = feed.Name;
                });
            }
        };
    });
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/azure_service_fabric_app/Octopus.AzureServiceFabricApp.js
// module id = 7275739787821625
// module chunks = 1